export default [
  {
    title: '客户机构',
    fixed: 'left',
    dataIndex: 'userRootDeptName',
    key: 'userRootDeptName',
    width: 150
  },
  {
    title: '订单编号',
    fixed: 'left',
    dataIndex: 'orderNumber',
    key: 'orderNumber',
    width: 270
  },
  {
    title: '总金额',
    dataIndex: 'price',
    key: 'price',
    width: 100,
    scopedSlots: { customRender: 'price' }
  },
  {
    title: '商品名称',
    dataIndex: 'goodName',
    key: 'goodName'
  },
  {
    title: '商品数量',
    width: 70,
    dataIndex: 'amountPerDevice',
    key: 'amountPerDevice'
  },
  {
    title: '设备数量',
    width: 70,
    dataIndex: 'id',
    key: 'id',
    scopedSlots: { customRender: 'devicesNumber' }
  },
  {
    title: '购买总量',
    dataIndex: 'totalAmount',
    width: 70,
    key: 'totalAmount'
  },
  {
    title: '支付状态',
    width: 100,
    dataIndex: 'payState',
    key: 'payState',
    scopedSlots: { customRender: 'payState' }
  },
  {
    title: '支付类型',
    dataIndex: 'payType',
    key: 'payType',
    scopedSlots: { customRender: 'payType' }
  },
  {
    title: '支付平台单号',
    width: 260,
    dataIndex: 'transactionNo',
    key: 'transactionNo'
  },
  {
    title: '支付时间',
    dataIndex: 'paySuccessTime',
    key: 'paySuccessTime'
  },
  {
    title: '更新时间',
    dataIndex: 'updatedAt',
    key: 'updatedAt'
  }
]
